import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { FOUNDATION_ROUTES } from '../../route';

export function registerStart(): void {

  applicationModuleRegistry.register({
    entry: 'start',
    id: 'start',
    name: 'provider.start',
    route: FOUNDATION_ROUTES.DASHBOARD,
    order: 1,
  });
}
